import React from "react";
import { Modal, ModalBody } from "reactstrap";

const InfoModal = ({ message, show, onCloseClick }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Info</h4>
            <p className="text-muted mx-4 mb-0" style={{whiteSpace:"no-wrap"}}>{message}</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" className="btn w-sm btn-primary btn-label" data-bs-dismiss="modal" onClick={onCloseClick}>
            <i className="ri-close-line label-icon align-bottom"></i> Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default InfoModal;